import React from 'react';
import styled from 'styled-components';

const FullScreenView = ({
  image,
  imagePosition,
  children,
  ...props
}: {
  image: string;
  imagePosition?: string;
  children?: React.ReactNode;
}) => {
  return (
    <View
      {...props}
      style={{backgroundImage: `url(${image})`, backgroundPosition: imagePosition ?? 'center'}}>
      {children}
    </View>
  );
};
export default FullScreenView;

const View = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: center;
  background-size: cover;
  background-repeat: no-repeat;
`;
